import { LabelInfo } from './get-recomendations'

/**
 * Задача этой функции просто разделить на колонки
 *
 * @param param0
 * @param cols
 * @returns
 */
export default function splitIntoColumns([name, copies]: LabelInfo, cols: number): LabelInfo[] {
    // Вычисляем кол-во копий на колонку, округляем вверх
    const copiesInCol = Math.ceil(copies / cols)

    return Array(cols).fill([name, copiesInCol])
}
